import React from "react";
import FooterLink from "./FooterLink";

const FooterSection = (item) => {
  return (
    <div
      className={`border-lightblue-200/25 relative w-full cursor-pointer overflow-hidden border-b transition-opacity duration-300 hover:!opacity-100 focus:outline-none group-hover:opacity-50 sm:border-none ${
        item.open ? "bg-darkblue" : "bg-transparent"
      }`}
      onClick={() => item.onClick(item._uid)}
      onKeyDown={() => item.onClick(item._uid)}
      role="button"
      tabIndex="0"
    >
      {
        <div className="flex items-center justify-between">
          <div
            className={`tracking-wider font-semibold font-display sm:text-brightbgreen mb-4 hover:cursor-default lg:mb-7 ${
              item.open ? "text-brightgreen" : "sm:text-brightgreen text-brightgreen"
            }`}
          >
            {item.title}
          </div>
          <i
            className={`fal  transform transition-all duration-300 sm:!hidden text-2xl text-brightgreen font-bold ${
              item.open
                ? "fa-minus"
                : "fa-plus"
            }`}
          ></i>
        </div>
      }
      <div
        className={`ease-max-h mb-2 overflow-hidden transition-all duration-300 sm:max-h-[1000px] ${
          item.open ? "max-h-[1000px]" : "max-h-0"
        }`}
      >
        {item.links.map((link, index) => {
          return <FooterLink {...link} key={index} />;
        })}
      </div>
    </div>
  );
};

export default FooterSection;
